import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  nome: Yup.string().required('Este campo é obrigatório'),
  descricao: Yup.string().required('Este campo é obrigatório'),
  taxaCargaCartao: Yup.string().required('Este campo é obrigatório'),
});

export default validationSchema;
